import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDormitory } from '../../context/DormitoryContext';

const categories = ['すべて', 'サービス案内', '入学・進学', '寮・生活', '会社情報'];

const documents = [
  {
    id: 1,
    title: '虹橋株式会社 会社案内パンフレット',
    description: '会社概要・事業内容・グループ校情報をまとめた総合パンフレットです。',
    category: '会社情報',
    fileType: 'PDF',
    fileSize: '3.2 MB',
    pages: 16,
    updated: '2025年4月',
    icon: 'ri-building-line',
    color: 'sky',
    image: null,
    downloadUrl: null,
  },
  {
    id: 2,
    title: '大学進学支援サービス案内',
    description: '出願書類作成から入学後のフォローまで、進学支援の全サービスをご紹介します。',
    category: 'サービス案内',
    fileType: 'PDF',
    fileSize: '2.1 MB',
    pages: 12,
    updated: '2025年3月',
    icon: 'ri-graduation-cap-line',
    color: 'teal',
    image: null,
    downloadUrl: null,
  },
  {
    id: 3,
    title: '学生生活サポートガイド',
    description: '在学中の生活支援・アルバイト紹介・メンタルケアなどのサポート内容をまとめています。',
    category: 'サービス案内',
    fileType: 'PDF',
    fileSize: '1.8 MB',
    pages: 10,
    updated: '2025年3月',
    icon: 'ri-heart-line',
    color: 'sky',
    image: null,
    downloadUrl: null,
  },
  {
    id: 4,
    title: '学生寮 入居案内・料金表',
    description: '各寮の設備・ルール・月額費用・申込方法を詳しく説明した資料です。',
    category: '寮・生活',
    fileType: 'PDF',
    fileSize: '2.5 MB',
    pages: 8,
    updated: '2025年2月',
    icon: 'ri-home-4-line',
    color: 'teal',
    image: null,
    downloadUrl: null,
  },
  {
    id: 10,
    title: '泉町2F 宿舎 3DK（6床）入居案内',
    description: '蓮沼駅徒歩3分・三田線7分の好立地。3室一厅・6床の学生宿舎。家電完備、水道光熱費込み（上限1万円）。双人間30万/人・押金4万円。',
    category: '寮・生活',
    fileType: 'PDF',
    fileSize: '1.4 MB',
    pages: 4,
    updated: '2025年5月',
    icon: 'ri-home-smile-line',
    color: 'teal',
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/0bdef57e89993060e8a3850e4ffa678a.jpeg',
    downloadUrl: null,
    highlight: true,
  },
  {
    id: 11,
    title: '泉町3F 宿舎 2DK（3床）入居案内',
    description: '蓮沼駅徒歩3分・三田線7分の好立地。2室一厅・3床の学生宿舎。家電完備、水道光熱費込み（上限1万円）。双人間30万/人・単人間42万/人。',
    category: '寮・生活',
    fileType: 'PDF',
    fileSize: '1.2 MB',
    pages: 4,
    updated: '2025年5月',
    icon: 'ri-home-4-line',
    color: 'teal',
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/2a1f30e930aa6d173abdc3711c561bdf.jpeg',
    downloadUrl: null,
    highlight: true,
  },
  {
    id: 12,
    title: '高島平 女生宿舎 403号室 3DK（4床）入居案内',
    description: '高島平駅徒歩4分・三田線17分で西巣鴨へ。3室一厅・4床の女性専用宿舎。エアコン・冷蔵庫・洗濯機・熱水器・電飯鍋・電子レンジ・wifi完備、水道光熱費全包。',
    category: '寮・生活',
    fileType: 'PDF',
    fileSize: '1.5 MB',
    pages: 4,
    updated: '2025年5月',
    icon: 'ri-women-line',
    color: 'teal',
    image: 'https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/c13c4f63563339b1da6b8278e7dc7204.jpeg',
    downloadUrl: null,
    highlight: true,
  },
  {
    id: 5,
    title: '不動産リフォーム・清掃サービス資料',
    description: 'リフォーム工事・原状回復・清掃代行の対応範囲と料金体系をご確認いただけます。',
    category: 'サービス案内',
    fileType: 'PDF',
    fileSize: '1.6 MB',
    pages: 6,
    updated: '2025年1月',
    icon: 'ri-tools-line',
    color: 'sky',
    image: null,
    downloadUrl: null,
  },
  {
    id: 6,
    title: '日中マーケティング調査 サービス概要',
    description: '日本・中国両市場における市場調査・競合分析サービスの詳細資料です。',
    category: 'サービス案内',
    fileType: 'PDF',
    fileSize: '2.0 MB',
    pages: 10,
    updated: '2025年1月',
    icon: 'ri-bar-chart-line',
    color: 'teal',
    image: null,
    downloadUrl: null,
  },
  {
    id: 7,
    title: '不動産・経営コンサルティング案内',
    description: '不動産投資・経営戦略・法人設立支援など、コンサルティングサービスの全容をご紹介します。',
    category: 'サービス案内',
    fileType: 'PDF',
    fileSize: '2.3 MB',
    pages: 14,
    updated: '2024年12月',
    icon: 'ri-briefcase-line',
    color: 'sky',
    image: null,
    downloadUrl: null,
  },
  {
    id: 8,
    title: '入学願書・申込書類一式',
    description: '大学・専門学校への出願に必要な書類のテンプレートと記入例をまとめたパッケージです。',
    category: '入学・進学',
    fileType: 'PDF',
    fileSize: '1.2 MB',
    pages: 5,
    updated: '2025年4月',
    icon: 'ri-file-text-line',
    color: 'teal',
    image: null,
    downloadUrl: null,
  },
  {
    id: 9,
    title: '日本留学ガイドブック 2025年版',
    description: '日本での学生生活・ビザ・奨学金・アルバイトなど、留学に必要な情報を網羅したガイドです。',
    category: '入学・進学',
    fileType: 'PDF',
    fileSize: '4.5 MB',
    pages: 32,
    updated: '2025年4月',
    icon: 'ri-book-open-line',
    color: 'sky',
    image: null,
    downloadUrl: null,
  },
];

const colorMap: Record<string, string> = {
  sky: 'bg-sky-50 text-sky-600 border-sky-100',
  teal: 'bg-teal-50 text-teal-600 border-teal-100',
};

const iconBgMap: Record<string, string> = {
  sky: 'bg-sky-100 text-sky-600',
  teal: 'bg-teal-100 text-teal-600',
};

export default function DownloadsPage() {
  const { dormitories, getAvailableCount } = useDormitory();

  const [isScrolled, setIsScrolled] = useState(false);
  const [activeCategory, setActiveCategory] = useState('すべて');
  const [searchQuery, setSearchQuery] = useState('');
  const [downloadedIds, setDownloadedIds] = useState<number[]>([]);
  const [applyModal, setApplyModal] = useState<{ open: boolean; docTitle: string }>({ open: false, docTitle: '' });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const filtered = documents.filter((doc) => {
    const matchCat = activeCategory === 'すべて' || doc.category === activeCategory;
    const matchSearch =
      doc.title.includes(searchQuery) || doc.description.includes(searchQuery);
    return matchCat && matchSearch;
  });

  const handleDownload = (id: number) => {
    setDownloadedIds((prev) => [...prev, id]);
    setTimeout(() => {
      setDownloadedIds((prev) => prev.filter((i) => i !== id));
    }, 2000);
  };

  const openApplyModal = (title: string) => {
    setApplyModal({ open: true, docTitle: title });
    setSubmitStatus('idle');
  };

  const closeApplyModal = () => {
    setApplyModal({ open: false, docTitle: '' });
    setSubmitStatus('idle');
    formRef.current?.reset();
  };

  const handleApplySubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitStatus('sending');
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as any);
    try {
      const res = await fetch('https://readdy.ai/api/form/d6ppkd4ddmmni7ck86gg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setSubmitStatus('success');
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    }
  };

  // 共有ステートから宿舎の空室情報を取得
  const getDormAvailable = (id: number) => {
    const dorm = dormitories.find((d) => d.id === id);
    if (!dorm) return null;
    const available = getAvailableCount(dorm);
    const total = dorm.rooms.length;
    return { available, total, rooms: dorm.rooms };
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/4f1bfceebacf762bbb456cb39f739307.png"
              alt="虹橋株式会社"
              className="h-10 w-auto object-contain"
            />
          </Link>
          <div className="flex items-center space-x-8">
            <Link to="/#about" className="text-sm font-medium text-slate-700 hover:text-sky-500 transition-colors whitespace-nowrap cursor-pointer">企業情報</Link>
            <Link to="/#services" className="text-sm font-medium text-slate-700 hover:text-sky-500 transition-colors whitespace-nowrap cursor-pointer">サービス</Link>
            <Link to="/#testimonials" className="text-sm font-medium text-slate-700 hover:text-sky-500 transition-colors whitespace-nowrap cursor-pointer">お客様の声</Link>
            <Link to="/downloads" className="text-sm font-medium text-sky-600 border-b border-sky-500 whitespace-nowrap cursor-pointer">資料ダウンロード</Link>
            <Link to="/contact" className="text-sm font-medium text-slate-700 hover:text-sky-500 transition-colors whitespace-nowrap cursor-pointer">お問い合わせ</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-sky-50 via-white to-teal-50"></div>
        <div className="relative max-w-4xl mx-auto px-6 text-center">
          <span className="inline-block text-xs font-light tracking-widest text-sky-500 mb-4 uppercase">Downloads</span>
          <h1 className="text-4xl lg:text-5xl font-light text-slate-800 mb-5" style={{ fontFamily: 'serif' }}>
            資料ダウンロード
          </h1>
          <p className="text-sm text-slate-500 leading-relaxed mb-10">
            虹橋株式会社のサービス案内・パンフレット・各種申込書類を<br />
            こちらからダウンロードいただけます。
          </p>
          <div className="max-w-xl mx-auto relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-slate-400">
              <i className="ri-search-line text-base"></i>
            </div>
            <input
              type="text"
              placeholder="資料名・キーワードで検索..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-full text-sm focus:outline-none focus:border-sky-400 bg-white shadow-sm"
            />
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="sticky top-16 z-40 bg-white border-b border-gray-100 shadow-sm">
        <div className="max-w-6xl mx-auto px-6 py-3 flex items-center space-x-2 overflow-x-auto">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap cursor-pointer transition-all ${
                activeCategory === cat
                  ? 'bg-sky-500 text-white shadow-sm'
                  : 'bg-gray-100 text-slate-600 hover:bg-sky-50 hover:text-sky-600'
              }`}
            >
              {cat}
            </button>
          ))}
          <span className="ml-auto text-xs text-slate-400 whitespace-nowrap pl-4">
            {filtered.length}件
          </span>
        </div>
      </section>

      {/* Documents Grid */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          {filtered.length === 0 ? (
            <div className="text-center py-24 text-slate-400">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-search-line text-5xl"></i>
              </div>
              <p className="text-sm">該当する資料が見つかりませんでした。</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((doc) => {
                const dormInfo = getDormAvailable(doc.id);
                return (
                  <div
                    key={doc.id}
                    className={`bg-white border rounded-2xl overflow-hidden hover:shadow-md transition-all group ${
                      (doc as any).highlight ? 'border-teal-200 shadow-sm' : 'border-gray-100'
                    }`}
                  >
                    {(doc as any).image && (
                      <div className="relative w-full h-44 overflow-hidden">
                        <img
                          src={(doc as any).image}
                          alt={doc.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                        />
                        {dormInfo && (
                          <div className="absolute top-3 left-3">
                            {dormInfo.available === 0 ? (
                              <span className="inline-flex items-center space-x-1 px-2.5 py-1 rounded-full text-xs font-medium bg-slate-700/80 text-white backdrop-blur-sm">
                                <i className="ri-close-circle-line"></i>
                                <span>満室</span>
                              </span>
                            ) : (
                              <span className="inline-flex items-center space-x-1 px-2.5 py-1 rounded-full text-xs font-medium bg-green-500/90 text-white backdrop-blur-sm">
                                <i className="ri-checkbox-circle-line"></i>
                                <span>空室あり {dormInfo.available}/{dormInfo.total}室</span>
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="p-6">
                      <div className="flex items-start justify-between mb-4">
                        <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconBgMap[doc.color]}`}>
                          <i className={`${doc.icon} text-xl`}></i>
                        </div>
                        <span className={`text-xs px-2.5 py-1 rounded-full border ${colorMap[doc.color]}`}>
                          {doc.category}
                        </span>
                      </div>

                      <h3 className="text-sm font-semibold text-slate-800 mb-2 leading-snug group-hover:text-sky-600 transition-colors">
                        {doc.title}
                      </h3>
                      <p className="text-xs text-slate-500 leading-relaxed mb-5">
                        {doc.description}
                      </p>

                      {/* 空室詳細テーブル（宿舎物件のみ・共有ステートから取得） */}
                      {dormInfo && (
                        <div className="mb-5 rounded-xl overflow-hidden border border-teal-100 text-xs">
                          <div className="bg-teal-50 px-3 py-2 font-semibold text-teal-700 flex items-center justify-between">
                            <span className="flex items-center space-x-1">
                              <i className="ri-door-open-line"></i>
                              <span>空室状況</span>
                            </span>
                            <span className={`font-normal ${dormInfo.available === 0 ? 'text-slate-500' : 'text-green-600'}`}>
                              {dormInfo.available}/{dormInfo.total} 空室
                            </span>
                          </div>
                          <table className="w-full text-slate-600">
                            <thead>
                              <tr className="bg-gray-50 text-slate-400">
                                <th className="px-3 py-1.5 text-left font-medium">部屋</th>
                                <th className="px-3 py-1.5 text-center font-medium">状況</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dormInfo.rooms.map((room) => (
                                <tr key={room.name} className="border-t border-gray-100">
                                  <td className="px-3 py-1.5">{room.name}</td>
                                  <td className="px-3 py-1.5 text-center">
                                    {room.status === 'available' ? (
                                      <span className="inline-flex items-center space-x-0.5 px-2 py-0.5 rounded-full bg-green-50 text-green-600 border border-green-100">
                                        <i className="ri-checkbox-circle-line text-xs"></i>
                                        <span>空室</span>
                                      </span>
                                    ) : (
                                      <span className="inline-flex items-center space-x-0.5 px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 border border-slate-200">
                                        <i className="ri-close-circle-line text-xs"></i>
                                        <span>満室</span>
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="bg-teal-50/60 px-3 py-2 text-teal-700 flex items-center justify-between">
                            <span className="flex items-center space-x-1">
                              <i className="ri-information-line"></i>
                              <span>最新状況は宿舎管理ページをご確認ください</span>
                            </span>
                            <Link to="/dormitory" className="flex items-center space-x-0.5 text-teal-500 hover:text-teal-400 font-medium cursor-pointer whitespace-nowrap">
                              <span>詳細</span>
                              <i className="ri-arrow-right-s-line"></i>
                            </Link>
                          </div>
                        </div>
                      )}

                      <div className="flex items-center space-x-4 text-xs text-slate-400 mb-5">
                        <span className="flex items-center space-x-1">
                          <i className="ri-file-pdf-line text-red-400"></i>
                          <span>{doc.fileType}</span>
                        </span>
                        <span className="flex items-center space-x-1">
                          <i className="ri-file-list-line"></i>
                          <span>{doc.pages}ページ</span>
                        </span>
                        <span className="flex items-center space-x-1">
                          <i className="ri-hard-drive-line"></i>
                          <span>{doc.fileSize}</span>
                        </span>
                      </div>

                      <div className="flex items-center justify-between gap-2">
                        <span className="text-xs text-slate-400 shrink-0">更新：{doc.updated}</span>
                        <div className="flex items-center gap-2">
                          {doc.category === '寮・生活' && (
                            <button
                              onClick={() => openApplyModal(doc.title)}
                              className="flex items-center space-x-1.5 px-3 py-2 rounded-lg text-xs font-medium bg-teal-500 text-white hover:bg-teal-400 transition-all whitespace-nowrap cursor-pointer"
                            >
                              <i className="ri-edit-line"></i>
                              <span>入居申込</span>
                            </button>
                          )}
                          <button
                            onClick={() => handleDownload(doc.id)}
                            className={`flex items-center space-x-1.5 px-4 py-2 rounded-lg text-xs font-medium transition-all whitespace-nowrap cursor-pointer ${
                              downloadedIds.includes(doc.id)
                                ? 'bg-green-500 text-white'
                                : 'bg-sky-500 text-white hover:bg-sky-400'
                            }`}
                          >
                            {downloadedIds.includes(doc.id) ? (
                              <>
                                <i className="ri-check-line"></i>
                                <span>完了</span>
                              </>
                            ) : (
                              <>
                                <i className="ri-download-line"></i>
                                <span>ダウンロード</span>
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Request Banner */}
      <section className="py-16 bg-gradient-to-r from-sky-50 to-teal-50">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="w-14 h-14 flex items-center justify-center mx-auto mb-5 bg-sky-100 rounded-full text-sky-600">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="text-2xl font-light text-slate-800 mb-3" style={{ fontFamily: 'serif' }}>
            必要な資料が見つかりませんでしたか？
          </h2>
          <p className="text-sm text-slate-500 mb-8 leading-relaxed">
            掲載されていない資料や、個別のご要望がございましたら<br />
            お気軽にお問い合わせください。担当者よりご対応いたします。
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center space-x-2 bg-sky-500 text-white px-8 py-3.5 rounded-lg text-sm hover:bg-sky-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>資料請求・お問い合わせ</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 text-white py-8">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-2">
            <img
              src="https://static.readdy.ai/image/b2ad99a010827991956f87b3b8c8a32e/4f1bfceebacf762bbb456cb39f739307.png"
              alt="虹橋株式会社"
              className="h-8 w-auto object-contain brightness-0 invert"
            />
            <span className="font-bold text-base">虹橋株式会社</span>
          </div>
          <p className="text-xs text-gray-400">© 虹橋株式会社 2025 All rights reserved</p>
        </div>
      </footer>

      {/* 入居申込モーダル */}
      {applyModal.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
              <div className="flex items-center space-x-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-teal-100 text-teal-600">
                  <i className="ri-home-smile-line text-lg"></i>
                </div>
                <div>
                  <h2 className="text-base font-semibold text-slate-800">入居申込フォーム</h2>
                  <p className="text-xs text-slate-400 mt-0.5 leading-tight">{applyModal.docTitle}</p>
                </div>
              </div>
              <button
                onClick={closeApplyModal}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-slate-400 cursor-pointer transition-colors"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <div className="px-6 py-6">
              {submitStatus === 'success' ? (
                <div className="text-center py-10">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-teal-100 rounded-full text-teal-500">
                    <i className="ri-check-double-line text-3xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-slate-800 mb-2">申込を受け付けました</h3>
                  <p className="text-sm text-slate-500 mb-6">担当者より3営業日以内にご連絡いたします。</p>
                  <button
                    onClick={closeApplyModal}
                    className="px-6 py-2.5 bg-teal-500 text-white rounded-lg text-sm hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    閉じる
                  </button>
                </div>
              ) : (
                <form ref={formRef} onSubmit={handleApplySubmit} data-readdy-form className="space-y-4">
                  <input type="hidden" name="物件名" value={applyModal.docTitle} />

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">お名前 <span className="text-red-400">*</span></label>
                      <input type="text" name="お名前" required placeholder="山田 太郎"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">フリガナ</label>
                      <input type="text" name="フリガナ" placeholder="ヤマダ タロウ"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1.5">メールアドレス <span className="text-red-400">*</span></label>
                    <input type="email" name="email" required placeholder="example@email.com"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1.5">電話番号 <span className="text-red-400">*</span></label>
                    <input type="tel" name="電話番号" required placeholder="090-0000-0000"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">国籍</label>
                      <input type="text" name="国籍" placeholder="中国"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">在留資格</label>
                      <select name="在留資格"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors cursor-pointer">
                        <option value="">選択してください</option>
                        <option value="留学">留学</option>
                        <option value="特定活動">特定活動</option>
                        <option value="技術・人文知識・国際業務">技術・人文知識・国際業務</option>
                        <option value="その他">その他</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">入居希望日 <span className="text-red-400">*</span></label>
                      <input type="date" name="入居希望日" required
                        className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors cursor-pointer" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1.5">希望部屋</label>
                      <select name="希望部屋"
                        className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors cursor-pointer">
                        <option value="">指定なし</option>
                        <optgroup label="泉町2F（3DK・6床）">
                          <option value="2F 双人間1">双人間1</option>
                          <option value="2F 双人間2">双人間2</option>
                          <option value="2F 双人間3">双人間3</option>
                        </optgroup>
                        <optgroup label="泉町3F（2DK・3床）">
                          <option value="3F 双人間">双人間</option>
                          <option value="3F 単人間">単人間</option>
                        </optgroup>
                        <optgroup label="高島平 女生宿舎（3DK・4床）">
                          <option value="高島平 双人間（和室2）">双人間（和室2）</option>
                          <option value="高島平 双人間（和室3）">双人間（和室3）</option>
                        </optgroup>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-slate-600 mb-1.5">備考・ご質問</label>
                    <textarea name="備考" rows={3} maxLength={500}
                      placeholder="ご質問・ご要望があればご記入ください（500文字以内）"
                      className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-teal-400 transition-colors resize-none" />
                  </div>

                  {submitStatus === 'error' && (
                    <p className="text-xs text-red-500 flex items-center space-x-1">
                      <i className="ri-error-warning-line"></i>
                      <span>送信に失敗しました。時間をおいて再度お試しください。</span>
                    </p>
                  )}

                  <div className="flex items-center gap-3 pt-2">
                    <button type="button" onClick={closeApplyModal}
                      className="flex-1 py-2.5 border border-gray-200 rounded-lg text-sm text-slate-600 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                      キャンセル
                    </button>
                    <button type="submit" disabled={submitStatus === 'sending'}
                      className="flex-1 py-2.5 bg-teal-500 text-white rounded-lg text-sm font-medium hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60 flex items-center justify-center space-x-2">
                      {submitStatus === 'sending' ? (
                        <><i className="ri-loader-4-line animate-spin"></i><span>送信中...</span></>
                      ) : (
                        <><i className="ri-send-plane-line"></i><span>申込を送信する</span></>
                      )}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
